import Lot from './component'

export default Lot
